import BarChartWithInfoSnippets from '../BarChartWithInfoSnippets';
import withErrorBoundary from '../ErrorBoundary';

import type { CarHireCheapestProviderProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CarHireCheapestProviderProps';

const CarHireCheapestProvider = (props: CarHireCheapestProviderProps) => (
  <BarChartWithInfoSnippets {...props} testId="carHireCheapestProvider" />
);

export default withErrorBoundary(
  CarHireCheapestProvider,
  'car-hire-cheapest-provider-component',
);
